var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_1636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.6838 0.5 0 3.1835 0 6.5C0 9.81615 2.6835 12.5 6 12.5C9.3162 12.5 12 9.8165 12 6.5C12 3.18385 9.3165 0.5 6 0.5ZM6 11.6628C3.15323 11.6628 0.837211 9.34679 0.837211 6.5C0.837211 3.65321 3.15323 1.33721 6 1.33721C8.84677 1.33721 11.1628 3.65321 11.1628 6.5C11.1628 9.34679 8.84677 11.6628 6 11.6628Z",
    fill: "#032146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 5.5015C5.64476 5.5015 5.39203 5.65159 5.39203 5.87272V8.88177C5.39203 9.07133 5.64476 9.26085 6.00016 9.26085C6.33977 9.26085 6.61617 9.07133 6.61617 8.88177V5.87267C6.61617 5.65157 6.33977 5.5015 6.00016 5.5015Z",
    fill: "#032146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00014 3.6455C5.63684 3.6455 5.35254 3.90613 5.35254 4.20624C5.35254 4.50638 5.63686 4.77491 6.00014 4.77491C6.35555 4.77491 6.63989 4.50638 6.63989 4.20624C6.63989 3.90613 6.35552 3.6455 6.00014 3.6455Z",
    fill: "#032146"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_1636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.f25ad37bb72ea5c4d87936edf9e9e0ba.svg";
export { ForwardRef as ReactComponent };